/* Reviews widget review slider - see snippets/reviews-widget.liquid
 *
 * jQuery is loaded globally in theme.liquid and slick is loaded by the snippet, both with
 * defer, so by the time this file runs both are available. The guard below keeps the widget
 * from throwing if either fails to load: the CSS already falls back to showing just the
 * first review when slick has not initialised. */
(function () {
  function initReviewSliders() {
    var $ = window.jQuery;

    if (!$ || !$.fn || !$.fn.slick) return;

    $('.reviews-widget__reviews')
      .not('.slick-initialized')
      .slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        // The track follows each review's own height rather than being held at the tallest.
        // Note this means the panel height changes between slides.
        adaptiveHeight: true,
        // fade is incompatible with the flex track the CSS uses to do that centring.
        fade: false,
        autoplay: true,
        autoplaySpeed: 6000,
        pauseOnHover: true,
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewSliders);
  } else {
    initReviewSliders();
  }

  // Re-initialise when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', initReviewSliders);
})();
